export default __webpack_public_path__ + "static/media/wechat_ico.088671cd.png";